import { Box, Card, Spinner } from '@factorialco/deprecated-design-system'

import { SPINNER_CONFIG } from 'modules/performance_analytics/components/Headcount/lib/constants'

export const LoadingState = () => {
  return (
    <Box height={SPINNER_CONFIG.height} width="full">
      <Card>
        <Card.Content>
          <Box alignSelf="center" flexDirection="column">
            <Box paddingTop={SPINNER_CONFIG.paddingTop}>
              <Spinner />
            </Box>
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )
}
